import React, { useState, useEffect } from 'react';
import './Header.css';


const SearchIconHeader = ({toggleMobileSearch}: {toggleMobileSearch: () => void}) => {
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasAnimated(true);
    }, 200); // Small delay for better effect
    return () => clearTimeout(timer);
  }, []);

  return (
    <button 
      className={`mobile-search-button ${hasAnimated ? 'animated' : ''}`}
      onClick={toggleMobileSearch}
      aria-label="Open search"
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8"/>
        <path d="m21 21-4.35-4.35"/>
      </svg>
    </button>
  );
};

export default SearchIconHeader;
